import script from "./dependents-incorporation-form-success.vue?vue&type=script&setup=true&lang=js"
export * from "./dependents-incorporation-form-success.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__